module.exports = __webpack_public_path__ + "static/media/ProximaNova-Semibold.75a4bbf1.svg";